import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './Header.module.css';
import SideDrawer from '../SideDrawer/SideDrawer';

//images 
import RESIST from '../../shared/images/Resist.png';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className={styles.header}>
        <div className={styles.headerRow}>
            {/* Left controls */}
            <div className={styles.leftGroup}>
                <button
                    className={`${styles.hamburger} ${menuOpen ? styles.hidden : ''}`}
                    onClick={() => setMenuOpen(true)}
                    aria-label="Open menu"
                >
                    <span />
                    <span />
                    <span />
                </button>

                <img
                src={RESIST}
                alt="Ogden Community Actions"
                className={styles.logo}
                />
            </div>

        {/* Centered title */}
            <div className={styles.centerGroup}>
                <h1>Ogden Community Actions</h1>
                <h5>
                this page is unaffiliated, community focused and politically agnostic*
                </h5>
            </div>
        </div>

      <SideDrawer open={menuOpen} onClose={() => setMenuOpen(false)} />

    </header>
  );
}

export default Header;
